export const api = {
  passportLogin: '/authentication/server/login/passport_login', // 京东passport联合登录
  logout: '/authentication/server/login/logout', // 退出登录
  getUserInfo: '/authentication/getLoginUserInfo', // 获取用户登录后roleList appResourceInfoList
  getUserList:
    '/permission/server/basic/user/get_user_info_of_company_by_username', // 获取用户的京东PIN绑定的账号列表接口
  getVehicleInfo: `/monitor/web/basic/vehicle`, // 车辆基础数据接口
  getScheduleStopState: `/monitor/web/schedule/stop/detail`, // 调度停靠点实时信息
  getOrderList: `/monitor/web/order/list`, // 订单详情
  getOrderVerifyCode: `/monitor/web/order/verify_code`, // 订单短信服务
  getVehicleWheelInfo: `/monitor/web/guardian/wheel_info`, // 获取车辆胎压数据
  getVehicleLauchState: `/monitor/web/guardian/lauch_state`, // 获取车辆启动进度数据
  getOperationList: `/monitor/web/operation/list`, // 操作历史
  getAccidentList: '/monitor/web/accident/get_accident_page_list', // 监控工单-事故管理列表
  getProblemReportList: '/ticket/web/data/get_problem_report_data_list', // 监控工单-问题提报工单列表
  getOpsDataList: `/ticket/web/data/get_ops_data_list`, // 监控工单-运维工单列表
  getCockpitDataList: `/monitor/web/data/get_cockpit_data_list`, // 监控工单-运维工单列表
  getCockpitTeamDataList: `/monitor/web/data/get_cockpit_team_data_list`, // 监控工单-运维工单列表
  getTechSupportDataList: `/monitor/web/data/get_support_data_list`, // 监控工单-运维工单列表
  getErrorList: `/monitor/web/guardian/exception/list`, // 监控工单-错误信息列表
  getIssueDetail: `/monitor/web/issue/detail`, // 查询工单详情
  getUserMetadataVehicle: `/monitor/web/basic/user_metadata`, // 用户权限下全部车号
  getUserMetadataCity: `/monitor/web/basic/user_metadata`, // 用户权限下全部城市-站点-车辆
  getEventDataList: '/monitor/web/guardian/alarm/list', // 监控工单-事件信息列表
  updateJiraAssitReport: '/monitor/web/guardian/alarm/update', // 监控工单-提报信息-更新车辆告警信息
  getNoReportIssueList: '/monitor/web/issue/issue-list', // 单车页查询工单列表
  submitJira: '/monitor/web/jira/report', // 提报jira
  getWorkOrderDetail: '/monitor/web/issue/detail', // 工单处理：查询工单详情
  emergencyStop: '/monitor/web/command/emergency_stop',
  recovery: '/monitor/web/command/recovery',
  restart: '/monitor/web/command/restart',
  asArrived: '/monitor/web/command/as_arrived',
  getGuardianException: '/monitor/web/guardian/exception', // 根据告警获取错误信息
  getRealtimeMileageFinished: '/monitor/web/realtime/mileage/finished', // 获取已走里程数
  powerOff: '/monitor/web/command/power/manager/{{POWER_OFF}}',
  reboot: '/monitor/web/command/power/manager/{{REBOOT}}',
  estop: '/monitor/web/command/estop_button', // 退出按钮急停
  getVehicleRealtimeInfo: '/monitor/web/jira/get_vehicle_realtime_info', //获取车辆历史实时信息
};
